import { useQuery } from '@tanstack/react-query';

import { fetchHistory } from '@/api/me';

export function useHistory(limit = 50) {
  return useQuery({
    queryKey: ['miniapp', 'history', limit],
    queryFn: () => fetchHistory(limit),
    staleTime: 30 * 1000,
  });
}
